import React from 'react';
import ReferralCriteria from '../Components/ReferralCriteria';

function WithBreastCancer() {
    return ReferralCriteria({
        criteria: [
            (<>Individual with breast cancer diagnosed at or under 30 years of age</>),
            (<>Individual with bilateral (2 primaries) breast cancer diagnosed under 50 years of age</>),
            (<>Individual with triple negative breast cancer diagnosed under 60 years of age</>),
            (<>Individual with male breast cancer under 60 or with a first degree relative with breast or ovarian cancer</>),
            (<>Individual with breast cancer under the age of 45 and a first degree relative with breast cancer (age &lt; 45 years) or ovarian cancer at any age</>)
        ],
        properties: {
            color: 'pink'
        }
    });
}

export default WithBreastCancer;
